export const isValidURL = (url) => {
  if (!url) return false
  try {
    // eslint-disable-next-line no-new
    new URL(url)
    return true
  } catch (error) {
    return false
  }
}

export const EMBED_URL_STRATEGIES = {
  'docs.google.com': (url) => url.replace('/pub?', '/embed?'),
  'youtube.com/watch': (url) => {
    const videoId = url.match(/[?&]v=([^&]+)/)?.[1]
    return videoId ? `https://www.youtube.com/embed/${videoId}` : url
  },
  'youtu.be': (url) => {
    const videoId = url.match(/youtu\.be\/([^?]+)/)?.[1]
    return videoId ? `https://www.youtube.com/embed/${videoId}` : url
  },
  'miro.com/app/board/': (url) => {
    const boardId = url.match(/board\/([^?&#]+)/)?.[1]
    return boardId ? `https://miro.com/app/embed/${boardId}` : url
  },
  'skoletube.dk/video/': (url) => {
    const videoId = url.match(/video\/[^/]+\/([^/]+)/)?.[1]
    return videoId ? `https://skoletube.dk/e/${videoId}` : url
  },
}
